import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Personal } from 'src/app/Models/personal/personal';
import { DataService } from 'src/app/Service/data.service';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';
import jsPDF from 'jspdf';
import { AlertComponent } from '../objects/alert/alert/alert.component';
import { LoadingComponent } from '../objects/loading/loading.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-print-reporte-utilidades',
  templateUrl: './print-reporte-utilidades.component.html',
  styleUrls: ['./print-reporte-utilidades.component.css']
})

export class PrintReporteUtilidadesComponent implements OnInit {
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;

  public isShow: boolean = false;
  public funcion: Function = null;
  public sucursales: any[] = [];
  public form: FormGroup;
  public today = new Date();

  public meses = [
    { value: 1,  label: 'Enero' },
    { value: 2,  label: 'Febrero' },
    { value: 3,  label: 'Marzo' },
    { value: 4,  label: 'Abril' },
    { value: 5,  label: 'Mayo' },
    { value: 6,  label: 'Junio' },
    { value: 7,  label: 'Julio' },
    { value: 8,  label: 'Agosto' },
    { value: 9,  label: 'Septiembre' },
    { value: 10, label: 'Octubre' },
    { value: 11, label: 'Noviembre' },
    { value: 12, label: 'Diciembre' },
  ];

  public anios: number[] = [];

  constructor(
    private fb: FormBuilder,
    private data: DataService,
    private datePipe: DatePipe,
    private reportViewer: ReportViewerService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.InitForm();
    this.GetSucursales();
    this.GenerarAnios();
  }

  GenerarAnios() {
    const actual = new Date().getFullYear();
    for (let a = actual; a >= actual - 4; a--) {
      this.anios.push(a);
    }
  }

  InitForm() {
    const today = new Date();
    this.form = this.fb.group({
      mes:        [today.getMonth() + 1, Validators.required],
      anio:       [today.getFullYear(),  Validators.required],
      idsucursal: ['']
    });
  }

  public show(fn: Function = null) {
    this.funcion = fn;
    this.isShow = true;
    this.cdr.detectChanges();
    this.btnshow.nativeElement.click();
  }

  GetSucursales() {
    this.data.GetSimple(this.data.api.sucursal).subscribe(r => {
      this.sucursales = r.data || r;
    });
  }

  GetReporte(): Promise<any> {
    const { mes, anio, idsucursal } = this.form.value;
    let url = `reporte-utilidades/?mes=${mes}&anio=${anio}`;
    if (idsucursal) url += `&idsucursal=${idsucursal}`;

    return new Promise((resolve, reject) => {
      this.loading.show('Generando reporte...');
      this.data.GetSimple(url).subscribe(
        r => { this.loading.hide(); resolve(r.data); },
        e => { this.loading.hide(); reject(e); }
      );
    });
  }

  getNombreMes(mes: number): string {
    return this.meses.find(m => m.value === Number(mes)).label || '';
  }

  async GenerarPDF() {
    try {
      const datos = await this.GetReporte();
      const blob = this.BuildPDF(datos);
      const fecha = this.format(new Date(), 'yyyy-MM-dd');
      this.reportViewer.mostrarPDF(blob, 'Reporte de Utilidades', `reporte_utilidades_${fecha}.pdf`);
    } catch (e) {
      this.data.notify('Error al generar el PDF', 'Error', this.data.alertType.error);
    }
  }

  async GenerarExcel() {
    try {
      const datos = await this.GetReporte();
      this.BuildExcel(datos);
    } catch (e) {
      this.data.notify('Error al generar el Excel', 'Error', this.data.alertType.error);
    }
  }

  BuildPDF(datos: any): Blob {
    const doc = new jsPDF();
    const { mes, anio } = this.form.value;
    const periodo = `${this.getNombreMes(mes)} ${anio}`;

    const addHeader = () => {
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      doc.text('REPORTE DE UTILIDADES', 75, 20);
      const tw = doc.getTextWidth('REPORTE DE UTILIDADES');
      doc.setLineWidth(0.5);
      doc.line(75, 21, 75 + tw, 21);
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.text(`Período: ${periodo}`, 10, 28);
      doc.text(`Generado el dia ${this.format(this.today, 'dd-MM-yyyy HH:mm')}`, 145, 28);
    };

    const tableRows: any[] = [
      ['VENTA BRUTA',              this.formatMonto(datos.venta_bruta)],
      ['(-) Inventario Inicial',   this.formatMonto(datos.inv_inicial)],
      ['(+) Compras del período',  this.formatMonto(datos.compras)],
      ['(-) Inventario Final',     this.formatMonto(datos.inv_final)],
      ['COSTO DE VENTAS',          this.formatMonto(datos.costo_ventas)],
      ['GASTOS',                   this.formatMonto(datos.gastos)],
      ['PLANILLA',                 this.formatMonto(datos.planilla)],
      ['UTILIDAD NETA',            this.formatMonto(datos.utilidad_neta)],
    ];

    const filasCostoIndices = [1, 2, 3];
    const filaCostoTotal    = 4;
    const filaUtilidad      = tableRows.length - 1;

    (doc as any).autoTable({
      head: [['CONCEPTO', 'MONTO (S/)']],
      body: tableRows,
      startY: 35,
      margin: { horizontal: 50 },
      theme: 'grid',
      columnStyles: {
        0: { halign: 'left', cellWidth: 80, fontStyle: 'normal' },
        1: { halign: 'right', cellWidth: 40 }
      },
      styles: { fontSize: 10, cellPadding: 3 },
      headStyles: { fillColor: [200, 200, 200], textColor: [0, 0, 0], fontStyle: 'bold' },
      didParseCell: (data: any) => {
        if (data.section !== 'body') return;
        // Detalle de costo en gris claro e indentado
        if (filasCostoIndices.includes(data.row.index) && data.column.index === 0) {
          data.cell.styles.fillColor  = [248, 248, 248];
          data.cell.styles.textColor  = [100, 100, 100];
          data.cell.styles.fontSize   = 9;
        }
        // Fila COSTO DE VENTAS en negrita
        if (data.row.index === filaCostoTotal) {
          data.cell.styles.fontStyle  = 'bold';
          data.cell.styles.fillColor  = [230, 230, 230];
        }
        // Fila UTILIDAD NETA en negrita
        if (data.row.index === filaUtilidad) {
          data.cell.styles.fontStyle  = 'bold';
          data.cell.styles.fillColor  = [236, 240, 241];
        }
        // Utilidad negativa en rojo
        if (data.row.index === filaUtilidad && data.column.index === 1 && datos.utilidad_neta < 0) {
          data.cell.styles.textColor  = [231, 76, 60];
        }
      },
      didDrawPage: (data: any) => {
        addHeader();
        doc.setFontSize(8);
        doc.text(`Página ${data.pageNumber}`, 180, 15);
      }
    });

    return doc.output('blob');
  }

  BuildExcel(datos: any) {
    const { mes, anio } = this.form.value;
    const periodo = `${this.getNombreMes(mes)} ${anio}`;

    const filas = [
      ['REPORTE DE UTILIDADES'],
      [`Período: ${periodo}`],
      [`Generado el dia ${this.format(this.today, 'dd-MM-yyyy HH:mm')}`],
      [],
      ['CONCEPTO', 'MONTO (S/)'],
      ['VENTA BRUTA',             datos.venta_bruta],
      ['(-) Inventario Inicial',  datos.inv_inicial],
      ['(+) Compras del período', datos.compras],
      ['(-) Inventario Final',    datos.inv_final],
      ['COSTO DE VENTAS',         datos.costo_ventas],
      ['GASTOS',                  datos.gastos],
      ['PLANILLA',                datos.planilla],
      [],
      ['UTILIDAD NETA',           datos.utilidad_neta],
    ];

    const ws = XLSX.utils.aoa_to_sheet(filas);
    ws['!cols'] = [{ wch: 28 }, { wch: 18 }];

    ['B6', 'B7', 'B8', 'B9', 'B10', 'B11', 'B12', 'B14'].forEach(cell => {
      if (ws[cell]) ws[cell].z = '#,##0.00';
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Utilidades');

    const fecha = this.format(new Date(), 'yyyy-MM-dd');
    XLSX.writeFile(wb, `reporte_utilidades_${fecha}.xlsx`);
  }

  formatMonto(valor: number): string {
    return `S/ ${Number(valor).toFixed(2)}`;
  }

  format(fecha: any, fmt: string): string {
    return this.datePipe.transform(fecha, fmt) || '';
  }

  close() {
    this.btnclose.nativeElement.click();
    setTimeout(() => { this.isShow = false; }, 500);
    setTimeout(() => { if (this.funcion) this.funcion(); }, 10);
  }
}
